var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
export var ACTIVITY_LINK_CLICK_ACTION = 'ActivityLinkClickAction';
export var ACTIVITY_POPUP_CLICK_ACTION = 'ActivityPopupClickAction';
export function mapLinkAndPopupClickAction(clickAction) {
  var _a, _b, _c, _d, _e, _f, _g, _h;
  if ((clickAction === null || clickAction === void 0 ? void 0 : clickAction.__typename) === ACTIVITY_LINK_CLICK_ACTION) {
    return {
      __typename: clickAction === null || clickAction === void 0 ? void 0 : clickAction.__typename,
      linkTagUrl: clickAction.linkTagUrl,
      anchorTagUrl: clickAction.anchorTagUrl,
      opensInNewTab: clickAction.opensInNewTab,
      accessibilityText: clickAction.accessibilityText,
      analytics: {
        __typename: (_a = clickAction.analytics) === null || _a === void 0 ? void 0 : _a.__typename,
        linkName: ((_b = clickAction.analytics) === null || _b === void 0 ? void 0 : _b.linkName) || '',
        microMessagePayload: ((_c = clickAction.analytics) === null || _c === void 0 ? void 0 : _c.microMessagePayload) || '',
        referrerId: ((_d = clickAction.analytics) === null || _d === void 0 ? void 0 : _d.referrerId) || ''
      }
    };
  }
  if ((clickAction === null || clickAction === void 0 ? void 0 : clickAction.__typename) === ACTIVITY_POPUP_CLICK_ACTION) {
    return {
      __typename: clickAction === null || clickAction === void 0 ? void 0 : clickAction.__typename,
      text: clickAction.messages,
      messages: clickAction.messages,
      title: clickAction.title,
      dismissAction: clickAction.dismissAction,
      analytics: {
        __typename: (_e = clickAction.analytics) === null || _e === void 0 ? void 0 : _e.__typename,
        linkName: ((_f = clickAction.analytics) === null || _f === void 0 ? void 0 : _f.linkName) || '',
        microMessagePayload: ((_g = clickAction.analytics) === null || _g === void 0 ? void 0 : _g.microMessagePayload) || '',
        referrerId: ((_h = clickAction.analytics) === null || _h === void 0 ? void 0 : _h.referrerId) || ''
      }
    };
  }
  return null;
}
export function mapMessageTileToBannerProps(message) {
  var _a, _b;
  var first = (_a = message === null || message === void 0 ? void 0 : message.action) === null || _a === void 0 ? void 0 : _a.first;
  var second = (_b = message === null || message === void 0 ? void 0 : message.action) === null || _b === void 0 ? void 0 : _b.second;
  var firstClickAction = mapLinkAndPopupClickAction(first === null || first === void 0 ? void 0 : first.clickAction);
  var secondClickAction = mapLinkAndPopupClickAction(second === null || second === void 0 ? void 0 : second.clickAction);
  return {
    __typename: 'ActivityMessageTile',
    type: message.type,
    title: message.title,
    subtitle: message.subtitle,
    icon: message.icon,
    mark: message.mark,
    graphic: message.graphic,
    signInButton: message.signInButton,
    action: {
      __typename: 'ActivityMessageAction',
      first: first && firstClickAction && {
        __typename: 'ActivityMessageClickAction',
        text: first.text,
        clickAction: firstClickAction
      },
      second: second && secondClickAction && {
        __typename: 'ActivityMessageClickAction',
        text: second.text,
        clickAction: secondClickAction
      }
    },
    className: ''
  };
}
export function mapLegalDisclaimerToBannerProps(legalDisclaimerBanner) {
  return {
    __typename: 'ActivityMessageTile',
    icon: legalDisclaimerBanner.icon && {
      __typename: 'Icon',
      id: legalDisclaimerBanner.icon.id || '',
      withBackground: legalDisclaimerBanner.icon.withBackground,
      description: ''
    },
    subtitle: {
      __typename: 'ActivityMessageTitle',
      text: legalDisclaimerBanner.title
    },
    className: ''
  };
}
export function mapLocalisationDisclaimerToBannerProps(localisationDisclaimerBanner) {
  return {
    __typename: 'ActivityMessageTile',
    icon: localisationDisclaimerBanner.icon && {
      __typename: 'Icon',
      id: localisationDisclaimerBanner.icon.id || '',
      withBackground: localisationDisclaimerBanner.icon.withBackground,
      description: ''
    },
    subtitle: {
      __typename: 'ActivityMessageTitle',
      text: localisationDisclaimerBanner.title
    },
    className: '',
    action: {
      __typename: 'ActivityMessageAction',
      first: localisationDisclaimerBanner.action && {
        __typename: 'ActivityMessageClickAction',
        text: localisationDisclaimerBanner.action.text,
        clickAction: {
          __typename: 'ActivityLinkClickAction',
          linkTagUrl: localisationDisclaimerBanner.action.href,
          anchorTagUrl: localisationDisclaimerBanner.action.href,
          opensInNewTab: false,
          accessibilityText: localisationDisclaimerBanner.action.accessibilityText
        }
      },
      second: localisationDisclaimerBanner.secondaryAction && {
        __typename: 'ActivityMessageClickAction',
        text: localisationDisclaimerBanner.secondaryAction.text,
        clickAction: {
          __typename: ACTIVITY_LINK_CLICK_ACTION,
          linkTagUrl: localisationDisclaimerBanner.secondaryAction.href,
          anchorTagUrl: localisationDisclaimerBanner.secondaryAction.href,
          opensInNewTab: true,
          accessibilityText: localisationDisclaimerBanner.secondaryAction.accessibilityText
        }
      }
    },
    openInNewWindow: true,
    linkActionDisplayDirection: 'column'
  };
}
export function mapPromotionMessageToBannerProps(message) {
  var _a, _b, _c, _d, _e, _f, _g, _h;
  var primaryAction = (_a = message.action) === null || _a === void 0 ? void 0 : _a.primary;
  var secondaryAction = (_b = message.action) === null || _b === void 0 ? void 0 : _b.secondary;
  var firstAction = (_c = message.clickAction) === null || _c === void 0 ? void 0 : _c.first;
  var secondAction = (_d = message.clickAction) === null || _d === void 0 ? void 0 : _d.second;
  var firstClickAction = mapLinkAndPopupClickAction(firstAction === null || firstAction === void 0 ? void 0 : firstAction.clickAction);
  var secondClickAction = mapLinkAndPopupClickAction(secondAction === null || secondAction === void 0 ? void 0 : secondAction.clickAction);
  var signInButton = message.signInButton;
  return {
    __typename: 'ActivityMessageTile',
    type: message.type,
    title: {
      text: message.title,
      __typename: 'ActivityMessageTitle'
    },
    subtitle: {
      text: message.subtitle,
      __typename: 'ActivityMessageTitle'
    },
    icon: message.icon,
    mark: message.mark,
    action: {
      __typename: 'ActivityMessageAction',
      first: firstAction && firstClickAction && {
        text: firstAction === null || firstAction === void 0 ? void 0 : firstAction.text,
        clickAction: firstClickAction,
        __typename: 'ActivityMessageClickAction'
      } || primaryAction && {
        text: ((_e = primaryAction.text) === null || _e === void 0 ? void 0 : _e.split(':')[0]) || undefined,
        __typename: 'ActivityMessageClickAction',
        clickAction: {
          __typename: ACTIVITY_LINK_CLICK_ACTION,
          anchorTagUrl: primaryAction.url,
          opensInNewTab: false,
          accessibilityText: '',
          analytics: {
            __typename: 'ActivityAnalytics',
            referrerId: ((_f = primaryAction.text) === null || _f === void 0 ? void 0 : _f.split(':')[1]) || '',
            linkName: ''
          }
        }
      },
      second: secondAction && secondClickAction && {
        __typename: 'ActivityMessageClickAction',
        text: secondAction === null || secondAction === void 0 ? void 0 : secondAction.text,
        clickAction: secondClickAction
      } || secondaryAction && {
        __typename: 'ActivityMessageClickAction',
        text: ((_g = secondaryAction.text) === null || _g === void 0 ? void 0 : _g.split(':')[0]) || undefined,
        clickAction: {
          __typename: ACTIVITY_LINK_CLICK_ACTION,
          anchorTagUrl: secondaryAction.url,
          opensInNewTab: false,
          accessibilityText: '',
          analytics: {
            __typename: 'ActivityAnalytics',
            referrerId: ((_h = secondaryAction.text) === null || _h === void 0 ? void 0 : _h.split(':')[1]) || '',
            linkName: ''
          }
        }
      }
    },
    signInButton: signInButton,
    className: ''
  };
}
export var trackAction = function (rfrr, linkName, analyticsStore, microMessagePayload) {
  if (analyticsStore && typeof analyticsStore.trackEvent === 'function') {
    analyticsStore.trackEvent(rfrr, linkName || 'RFRR Action Link', analyticsStore.omnitureData, null, true, microMessagePayload);
  }
};
export function mapMessagingCardMediaProps(icon, mark, styleClass) {
  var props = {};
  if (icon || mark) {
    props = __assign({}, props);
  }
  if (styleClass) {
    props = __assign(__assign({}, props), {
      className: styleClass
    });
  }
  return props;
}